var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _vm.showDownside
      ? _c(
          "div",
          { attrs: { id: "header_downside" } },
          [
            _c("dd-support-modal", {
              ref: "supportModalRef",
              on: { closeContact: _vm.closeContact }
            }),
            _vm._v(" "),
            _c("ul", { staticClass: "hddw_nav" }, [
              _c("li", [
                !_vm.dispTrialUserTools
                  ? _c("span", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "component/common/header/daros_logo_white.svg"
                          ),
                          width: "120px",
                          height: "auto"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dispTrialUserTools
                  ? _c("span", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "component/common/header/daro_try_logo.svg"
                          ),
                          width: "210px",
                          height: "auto"
                        }
                      })
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "li",
                { attrs: { id: "home_ico" } },
                [
                  !_vm.dispTrialUserTools
                    ? _c("router-link", { attrs: { to: "/" } }, [
                        _c("img", {
                          attrs: {
                            src: _vm.getImage(
                              "component/common/header/ic_top.svg"
                            ),
                            alt: "home"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("TOP")])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.dispTrialUserTools
                ? _c("li", { staticClass: "contact" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.showContact($event)
                          }
                        }
                      },
                      [_c("span", [_vm._v("お問い合わせ/お打合わせ依頼")])]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("li", { staticClass: "account" }, [
                _c("a", { on: { click: _vm.onClickCorpConfig } }, [
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("pages/planning/ic_corp.svg"),
                      alt: "company"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.userInfo.corpName))]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "arrow",
                    attrs: {
                      src: _vm.getImage(
                        "component/common/header/ic_arrow_right.svg"
                      ),
                      alt: "user"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              !_vm.dispTrialUserTools
                ? _c("li", { staticClass: "account" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.getImage("pages/planning/ic_user.svg"),
                            alt: "user"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.userInfo.userName))]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "arrow",
                          attrs: {
                            src: _vm.getImage(
                              "component/common/header/ic_arrow_right.svg"
                            ),
                            alt: "user"
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("li", { staticClass: "logout" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout($event)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.getImage(
                          "component/common/header/ic_logout.svg"
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Logout")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "header_downside_toggle" }, [
                !_vm.isDispMenu
                  ? _c("span", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage("pages/planning/ic_plus_off.svg"),
                          alt: "toggle",
                          width: "24px",
                          height: "auto"
                        },
                        on: {
                          click: function($event) {
                            _vm.$emit("onClickMenuToggle", true)
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "header_downside_toggle" }, [
                !_vm.isDispContent
                  ? _c("span", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage("pages/planning/ic_plus_on.svg"),
                          alt: "toggle",
                          width: "24px",
                          height: "auto"
                        },
                        on: {
                          click: function($event) {
                            _vm.$emit("onClickContentToggle", true)
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fbfe6be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fbfe6be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/Header.vue
// module id = null
// module chunks = 